import { render, staticRenderFns } from "./FormCrearCodigos.vue?vue&type=template&id=2296e29a"
import script from "./FormCrearCodigos.vue?vue&type=script&lang=js"
export * from "./FormCrearCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports